import request from './request'

export interface SetValueParams {
  id: number
  values: {
    condition: string[]
    location: string[]
    task: string[]
    time: string[]
    components?: Array<{
      component: string
      values: string[]
      field_type: string
    }>
  }
}

export interface SetValueResponse {
  code: number
  msg: string
  data?: {
    id: number
    values: {
      condition: string[]
      location: string[]
      task: string[]
      time: string[]
      components?: Array<{
        component: string
        values: string[]
        field_type: string
      }>
    }
  }
}

export function setSetValue(data: SetValueParams): Promise<SetValueResponse> {
  return request.post('/api/admin/checklist/set-value', data)
}

export function getSetValue(id: number): Promise<SetValueResponse> {
  return request.post('/api/admin/checklist/get-value', { id })
}
